__webpack_require__.p = "https://bmidxbspainplpreprod.netlify.app/";